<template>
  <div class="popup" @mousedown.self="close">
    <div class="popup-content" v-if="tempObject">
      <div class="header-popup-update">
        <span>Modification de votre article </span>
        <span title="Annuler" style="float:right;" class="cross" @click="close">&times;</span>
      </div>
      <hr />
      <input type="text" maxlength="40" placeholder="Titre de l'article" v-model="tempObject.Titre" id="titre">
      <div class="editor" id="editor">
        <vue-editor v-model="content" :editorToolbar="customToolbar"></vue-editor>
      </div>
      <div class="buttons">
        <div class="container-buttons">
          <label class="label" title="Visible dès la publicaiton">
              <div class="toggle">
                <input class="toggle-state" type="checkbox" name="check" v-model="tempObject.IsVisible" />
                <div class="toggle-inner">
                  <div class="indicator"></div>
                </div>
                <div class="active-bg"></div>
              </div>
          </label>
          <select class="form-select" v-model="selectedCateg" @change="changeCateg">
            <option v-for="categ of categList" :value="categ.Id" :key="categ.Id" >{{categ.Label}}</option>
          </select>
          <button class="cancel" @click="close">Annuler</button>
          <button class="publish" @click="updateArticle">Sauvegarder</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getCategories, updateArticle } from "@/utils/cms" //récupère les catégories de l'utilisateur et la fonction de mise à jour
  export default {
    name: 'CmsPreview',
    props: {
      article: Object
    },
    data() {
      return {
        categList: [],
        selectedCateg: -1,
        check: false,
        tempObject: null,
        content: '',
        customToolbar: [ // Toolbar de l'éditeur
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline", "strike"], // toggled buttons
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          ["link"],
          //["link", "image", "video"],
          ["clean"] // remove formatting button
        ]
      }
    },
    mounted() {
      var tempObject = { //Objet temporaire permettant de modifier directement le props dans le parent
        Titre: this.article.Titre,
        CategoryId: this.article.CategoryId,
        CategoryName: this.article.CategoryName,
        Corps: this.article.Corps,
        CreationDate: this.article.CreationDate,
        Id: this.article.Id,
        IsVisible: this.article.IsVisible,
        ModifiedDate: this.article.ModifiedDate
      }
      this.tempObject = tempObject;
      this.content = tempObject.Corps
      getCategories(this.$store.state.self.guid).then((response) => { //On récupère les catégories
        this.categList = response;
        this.selectedCateg = this.tempObject.CategoryId
      });
    },
    methods: {
      close: function () { //On annule la modification de l'article
        this.$emit('close');
        this.tempObject = null;
        this.content = "";
      },
      changeVisibility : function () { //Change la visibilité de l'article
        this.tempObject.IsVisible = !this.tempObject.IsVisible
      },
      updateArticle: function () { //On met à jour l'article
        this.tempObject.Corps = this.content; //On passe le text dans l'éditeur dans l'objet temporaire
        console.log(this.tempObject);
        if (this.tempObject.Titre === '') { //Vérification des champs
          document.getElementById('titre').style.borderColor = '#FF5252';
          return;
        } else document.getElementById('titre').style.borderColor = 'lightgrey';

        if (this.tempObject.Corps === '' || this.tempObject.Corps === '<br>') { //Vérification des champs
          document.getElementById('editor').style.borderColor = '#FF5252'
          return;
        } else document.getElementById('editor').style.borderColor = 'lightgrey'



        this.$emit('updateArticleVue', this.tempObject); //Change l'article dans le composant parent (affichage utilisateur)
        updateArticle( //appel à la bdd pour modifier l'article
          this.tempObject.Id,
          this.tempObject.Titre.trim(),
          this.tempObject.Corps,
          this.tempObject.IsVisible,
          this.tempObject.CategoryId
        )
        this.close();
      },
      changeCateg: function () { //Changement de catégorie dans l'objet temporaire
        this.categList.forEach(categorie => { //Pour chaque catégories
          if (categorie.Id === this.selectedCateg) { //Si l'id est pareil 
            this.tempObject.CategoryId = categorie.Id;
            this.tempObject.CategoryName = categorie.Label;
          }
        })
      }
    }
  };
</script>


<style>
  .popup {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(155, 155, 155, 0.8);
  }
  #editor{
      height: 400px;
      margin-top: 2%;
  }
    .popup > .popup-content {
      margin: 70px auto;
      padding: 20px;
      background: #fff;
      border-radius: 5px;
      width: 80%;
      height: 80%;
      max-height: 90%;
      overflow:auto;
      position: relative;
    }
  #titre {
    border: 1px solid lightgrey;
    margin-left: 0%;
    height: 40px;
    font-size: 1.5rem;
    width: 50%;
  }
  .header-popup-update span{
      font-size: 30px;
  }
  .header-popup-update .cross {
      cursor:pointer;
  }

  .buttons {
    width: 100%;
    margin-top: 2%;
    display: flex;
  }

  .container-buttons {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
  }

  .buttons .container-buttons button {
    margin-right: 1%;
    color: white;
    font-family: 'DIN Pro';
    border: none;
  }

  .buttons .container-buttons label {
    margin-right: 3%;
  }

  .buttons .container-buttons .form-select {
    width: 25%;
    margin-right: 3%;
  }

  .cancel {
    background: #FF5252;
  }

  .publish {
    background: #198754;
  }

  .cancel:hover {
    background: #d14646;
  }

  .publish:hover {
    background: #146741;
  }
  .label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .label-text {
    margin-left: 8px;
    color: black;
  }

  .toggle {
    isolation: isolate;
    position: relative;
    height: 24px;
    width: 48px;
    border-radius: 15px;
    background: #9c9b9b; /*d6d6d6*/
    overflow: hidden;
  }

  .toggle-inner {
    z-index: 2;
    position: absolute;
    top: 1px;
    left: 1px;
    height: 22px;
    width: 46px;
    border-radius: 15px;
    overflow: hidden;
  }

  .active-bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 200%;
    background: #80a70e;
    transform: translate3d(-100%, 0, 0);
    transition: transform 0.05s linear 0.17s;
  }

  .toggle-state {
    display: none;
  }

  .indicator {
    height: 100%;
    width: 200%;
    background: white;
    border-radius: 13px;
    transform: translate3d(-75%, 0, 0);
    transition: transform 0.35s cubic-bezier(0.85, 0.05, 0.18, 1.35);
  }

  .toggle-state:checked ~ .active-bg {
    transform: translate3d(-50%, 0, 0);
  }

  .toggle-state:checked ~ .toggle-inner .indicator {
    transform: translate3d(25%, 0, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components/Cms/CmsUpdateArticle.vue